import React from 'react'
import BaseIcon from 'react-icon-base'

const NG = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 6 3" {...props}>
    <title>Flag of Nigeria</title>
    <rect width="6" height="3" fill="#008751" />
    <rect x="2" width="2" height="3" fill="#FFF" />
  </BaseIcon>
)

export default NG
